import { render, staticRenderFns } from "./ProductSampleList.vue?vue&type=template&id=6b50de57&"
import script from "./ProductSampleList.vue?vue&type=script&lang=js&"
export * from "./ProductSampleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports